'use strict';

export class ConversationTile {
  constructor() {
    this.name = 'conversation-tile';
    console.log('%s module', this.name.toLowerCase());
    $('#ct-manual-list-18 .ct-item-grid__items .ct-item-grid__item').each(function(){
      var text_container = $(this).find(".ct-promo-card__summary").text();
      var list = text_container.split("-");
      console.log(list);
      for (var i = 0; i < list.length; i++) {
        $(this).find(".ct-promo-card__summary").append('<li>' + list[i] + '</li>');
      }

    })

  }
}
